import * as React from 'react';
import { IStore } from 'redux/IStore';
import {
	nextStep,
	previousStep,
	submitOnboardingQuiz,
	getInfluencersAndShopsToFollow,
	followInfluencer,
	followShop,
	unfollowInfluencer,
	unfollowShop,
	resetData,
	updateProfilePicture,
} from 'modules/onboardingquiz';
import { IOnboardingQuizAction, IOnboardingQuiz, IOnboardingQuizFormData } from 'models/onboardingquiz';
import { GetStarted } from './GetStarted';
import { Button, Modal } from 'components';
import { IModalAction } from 'models/modal';
import {
	getStyleDomainValues,
	getColorDomainValues,
	getSizeDomainValues,
	getSportDomainValues,
	getHobbyDomainValues,
	getTripDomainValues,
	getSocialDomainValues,
} from 'modules/domainvalues';
import { IDomainValuesAction } from 'models/domainvalues/domainvalues';
import { ICropImageData } from 'models/common';
import { destroy } from 'redux-form';
import * as c from 'models/constants';
import { Completed } from './Completed';
import { HairType } from './HairType';
import { HairColor } from './HairColor';
import { ScalpCondition } from './ScalpCondition';
import { HairRelatedGoal } from './HairRelatedGoal';
import { EyeColor } from './EyeColor';
import { NailsShape } from './NailsShape';
import { translate } from 'react-i18next';
import { HairLength } from './HairLength';
import { SkinProblem } from './SkinProblem';
import { UserInfo } from './UserInfo';
import { submitForm } from 'helpers/common';
import { ImageState } from 'components/FormControls/NewImageUpload';
const { connect } = require('react-redux');
require('./style.css');

interface IProps {
	onboardingQuiz?: IOnboardingQuiz;
	modalTitle: string;
	showHeaderCloseButton?: boolean;
	formState?: any;
	userProps?: any;

	/* functions props */
	t?: (key: string, options?: any) => string;
	nextStep: () => IOnboardingQuizAction;
	previousStep: () => IOnboardingQuizAction;
	submitOnboardingQuiz: (form: IOnboardingQuizFormData) => IOnboardingQuizAction;
	getInfluencersAndShopsToFollow: () => IOnboardingQuizAction;
	followInfluencer: (id: string) => IOnboardingQuizAction;
	followShop: (id: string) => IOnboardingQuizAction;
	unfollowInfluencer: (id: string) => IOnboardingQuizAction;
	unfollowShop: (id: string) => IOnboardingQuizAction;
	resetData: () => IOnboardingQuizAction;
	updateProfilePicture: (image: ICropImageData) => IOnboardingQuizAction;
	closeModal?: () => IModalAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	getStyleDomainValues?: () => IDomainValuesAction;
	getColorDomainValues?: () => IDomainValuesAction;
	getSizeDomainValues?: () => IDomainValuesAction;
	getSportDomainValues?: () => IDomainValuesAction;
	getHobbyDomainValues?: () => IDomainValuesAction;
	getTripDomainValues?: () => IDomainValuesAction;
	getSocialDomainValues?: () => IDomainValuesAction;
	destroy?: (form: string) => void;
}

@connect(
	(state: IStore) => {
		return {
			onboardingQuiz: state.onboardingQuiz,
			formState: state.form[c.FORM_NAME_ONBOARDING_QUIZ],
		};
	},
	(dispatch) => ({
		nextStep: () => dispatch(nextStep()),
		previousStep: () => dispatch(previousStep()),
		submitOnboardingQuiz: (form: IOnboardingQuizFormData) => dispatch(submitOnboardingQuiz(form)),
		getInfluencersAndShopsToFollow: () => dispatch(getInfluencersAndShopsToFollow()),
		followInfluencer: (id: string) => dispatch(followInfluencer(id)),
		followShop: (id: string) => dispatch(followShop(id)),
		unfollowInfluencer: (id: string) => dispatch(unfollowInfluencer(id)),
		unfollowShop: (id: string) => dispatch(unfollowShop(id)),
		resetData: () => dispatch(resetData()),
		updateProfilePicture: (image: ICropImageData) =>
			dispatch(
				updateProfilePicture({
					...image,
					thumbnails: c.DEFAULT_CROP_SIZES_PROFILE_IMAGE,
				}),
			),
		getStyleDomainValues: () => dispatch(getStyleDomainValues()),
		getColorDomainValues: () => dispatch(getColorDomainValues()),
		getSizeDomainValues: () => dispatch(getSizeDomainValues()),
		getSportDomainValues: () => dispatch(getSportDomainValues()),
		getHobbyDomainValues: () => dispatch(getHobbyDomainValues()),
		getTripDomainValues: () => dispatch(getTripDomainValues()),
		getSocialDomainValues: () => dispatch(getSocialDomainValues()),
		destroy: (form: string) => dispatch(destroy(form)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class OnboardingQuiz extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.onStartExploringClick = this.onStartExploringClick.bind(this);
		this.onImgStateChange = this.onImgStateChange.bind(this);

		this.state = {
			imageState: ImageState.ready,
		};
	}

	userInfoFormRef: React.RefObject<HTMLFormElement> = React.createRef();

	public componentDidMount() {
		this.props.getStyleDomainValues();
		this.props.getSizeDomainValues();
		this.props.getColorDomainValues();
		this.props.getHobbyDomainValues();
		this.props.getSportDomainValues();
		this.props.getTripDomainValues();
		this.props.getSocialDomainValues();
	}

	public componentWillUnmount() {
		this.props.resetData();
		this.props.destroy(c.FORM_NAME_ONBOARDING_QUIZ);
	}

	private onSubmit(form: IOnboardingQuizFormData) {
		this.props.submitOnboardingQuiz(form);
	}

	private onImgStateChange(state: ImageState) {
		this.setState({ imageState: state });
	}

	private onStartExploringClick() {
		this.props.closeModal();
	}

	public render() {
		const { t, closeModal, modalTitle, showHeaderCloseButton, previousStep, nextStep, formState, userProps } =
			this.props;
		const { wizardStep } = this.props.onboardingQuiz;

		var modalClass = 'modalOnboardingWrapper';
		if (wizardStep === 1) {
			modalClass += ' userInfo';
		} else if (wizardStep === 2) {
			modalClass = 'getStartedWrapper';
		} else if (wizardStep === 11) {
			modalClass = 'congratulations';
		}

		const titles = [
			null,
			t('OnboardingQuiz_Hair_Steps_Title'),
			t('OnboardingQuiz_Skin_Steps_Title'),
			t('OnboardingQuiz_Eyes_Steps_Title'),
			t('OnboardingQuiz_Nails_Steps_Title'),
		];

		return (
			<Modal
				modalClass={modalClass}
				title={modalTitle}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				size={wizardStep === 2 || wizardStep === 11 ? 'extraSmall' : 'normal'}
				footer={
					wizardStep === 1 && (
						<Button
							onClick={() => submitForm(this.userInfoFormRef?.current)}
							disabled={(formState && 'syncErrors' in formState) || this.state.imageState === ImageState.wait}
						>
							{t('BSPortal_Common_Save')}
						</Button>
					)
				}
			>
				{wizardStep === 1 && (
					<UserInfo
						formRef={this.userInfoFormRef}
						onImgStateChange={this.onImgStateChange}
						onSubmit={this.onSubmit}
						closeModal={closeModal}
						steps={titles}
						updateProfilePicture={this.props.updateProfilePicture}
						initialValues={userProps}
					/>
				)}
				{wizardStep === 2 && <GetStarted nextPage={nextStep} closeModal={closeModal} />}
				{wizardStep === 3 && <HairType onSubmit={nextStep} closeModal={closeModal} steps={titles} />}
				{wizardStep === 4 && <HairLength onSubmit={nextStep} previousPage={previousStep} steps={titles} />}
				{/* {wizardStep === 5 && <HairPorosity nextPage={nextStep} previousPage={previousStep} />} */}
				{wizardStep === 5 && <HairColor onSubmit={nextStep} previousPage={previousStep} steps={titles} />}
				{wizardStep === 6 && <ScalpCondition onSubmit={nextStep} previousPage={previousStep} steps={titles} />}
				{/* {wizardStep === 6 && <VisitHairdresser nextPage={nextStep} previousPage={previousStep} steps={titles} />} */}
				{/* {wizardStep === 7 && <HairCareProducts nextPage={nextStep} previousPage={previousStep} steps={titles} />} */}
				{/* {wizardStep === 7 && <ProductBrand onSubmit={nextStep} previousPage={previousStep} steps={titles} />} */}
				{wizardStep === 7 && <HairRelatedGoal onSubmit={nextStep} previousPage={previousStep} steps={titles} />}
				{wizardStep === 8 && <SkinProblem onSubmit={nextStep} previousPage={previousStep} steps={titles} />}
				{/* {wizardStep === 12 && <SkinType nextPage={nextStep} previousPage={previousStep} />} */}
				{wizardStep === 9 && <EyeColor onSubmit={nextStep} previousPage={previousStep} steps={titles} />}
				{wizardStep === 10 && <NailsShape onSubmit={this.onSubmit} previousPage={previousStep} steps={titles} />}
				{/* {wizardStep === 11 && <BodyType onSubmit={this.onSubmit} previousPage={previousStep} steps={titles} />}      */}
				{wizardStep === 11 && <Completed onStartExploringClick={this.onStartExploringClick} />}
			</Modal>
		);
	}
}

export { OnboardingQuiz };
